import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { createPortal } from "react-dom";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
// import { scaleQuantize } from 'd3-scale';
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import HelpOutlineIcon from "@mui/icons-material/HelpOutlined";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutlined";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import axios from "axios";
import { API_URL, AUTH_URL, CHAT_URL } from "../../utils/constants";
// import { truncateText } from '../../utils/utils';
import TruncatedText from "../../utils/TruncatedText";
import { toCamelCase, toSentenceCase, getOfficerGrievanceStatus, stripMarkdown } from "../../utils/utils";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "../../fonts/NotoSansDevanagari";
import SatisfactionGauge from "./SatisfactionIndex";
import BarCharts from "../dashboard/BarCharts";
import PieCharts from "../dashboard/PieCharts";
import upDownArrow from "../../assets/images/up-down-arrow.svg";
import AiSummaryModal from "../commonComponent/AiSummaryModal";
import FormattedMarkdown from "../commonComponent/FormattedMarkdown";
import { downloadBtrPdf, getBtrText } from "../../utils/btrPdf";
import { useRef } from "react";
// import CallUI from 'https://sea-lion-app-xp7yb.ondigitalocean.app/feedback';

const GRADIENT_COLORS = ["#FF852B", "#D37929", "#B34700"];

const stripMarkdownFence = (text) => {
  if (!text) return "";
  return text
    .replace(/^```[a-z]*\n?/i, "")
    .replace(/\n?```$/i, "")
    .trim();
};

const formatFeedbackCategory = (text) => {
  if (!text) return "";
  return text
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export default function AdminUser({ dashboardData, data, overdueData }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAdminModalOpen, setIsAdminModalOpen] = useState(false);
  const [isATROpen, setIsATROpen] = useState(false);
  const [isCommentOpen, setIsCommentOpen] = useState(false);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedTableData, setSelectedTableData] = useState(null);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [showCommentArea, setShowCommentArea] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [comment, setComment] = useState(""); // New state to store comment
  const [adminComment, setAdminComment] = useState(""); // New state to store comment
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [queryUpdate, setQueryUpdate] = useState(true);
  const [rating, setRating] = useState(true);
  const [pieChartData, setPieChartData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchParam, setSearchParam] = useState("All");
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const tableRef = useRef(null);
  const [atrSummary, setAtrSummary] = useState("");
  const [atrFile, setAtrFile] = useState(null);
  const [atrUploadLoading, setAtrUploadLoading] = useState(false);
  const [atrFileUrl, setAtrFileUrl] = useState("");
  const [audioFile, setAudioFile] = useState(null);
  const [audioUploadLoading, setAudioUploadLoading] = useState(false);
  const [audioSummary, setAudioSummary] = useState("");
  const [audioFileUrl, setAudioFileUrl] = useState("");
  const [response, setResponse] = useState("");
  const [aiSummaryOpen, setAiSummaryOpen] = useState(false);
  const [aiSummaryText, setAiSummaryText] = useState("");
  const [aiSummaryLoading, setAiSummaryLoading] = useState(false);
  // Table-level AI Summary (Complaints Over Time table inline button)
  const [tableAiSummaryOpen, setTableAiSummaryOpen] = useState(false);
  const [tableAiSummaryText, setTableAiSummaryText] = useState("");
  const [tableAiSummaryLoading, setTableAiSummaryLoading] = useState(false);
  const [tableAiSummaryRow, setTableAiSummaryRow] = useState(null);
  const [btrMode, setBtrMode] = useState(null); // null | 'generate' | 'upload'
  const [btrContent, setBtrContent] = useState("");
  const [tranferDept, setTransferDept] = useState("");
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchVal = params.get("search");
    if (searchVal) {
      setSearchQuery(searchVal);
    }
  }, [location.search]);
  const [btrFile, setBtrFile] = useState(null);
  const [btrFileUrl, setBtrFileUrl] = useState("");
  const [btrSummary, setBtrSummary] = useState("");
  const [btrLoading, setBtrLoading] = useState(false);
  const [btrSubmitLoading, setBtrSubmitLoading] = useState(false);
  const [btrTab, setBtrTab] = useState("preview");
  const [atrPopover, setAtrPopover] = useState(null); // { text, x, y }

  // BTR Pending for Admin Approval
  const [btrPendingList, setBtrPendingList] = useState([]);
  const [btrPendingLoading, setBtrPendingLoading] = useState(false);
  const [btrRejectModal, setBtrRejectModal] = useState(null); // row to reject
  const [btrRejectReason, setBtrRejectReason] = useState("");
  const [btrDetailModal, setBtrDetailModal] = useState(null); // row for detail view
  const [remindedIds, setRemindedIds] = useState(new Set()); // track reminded complaints
  const [remindCommentRow, setRemindCommentRow] = useState(null); // row with open comment box
  const [remindCommentText, setRemindCommentText] = useState(""); // comment text

  const fetchBtrPending = async () => {
    setBtrPendingLoading(true);
    try {
      const res = await axios.get(`${AUTH_URL}api/get_btr_pending`, {
        headers: { "Content-Type": "application/json" },
      });
      setBtrPendingList(res.data?.data || []);
    } catch (err) {
      console.error("Failed to fetch BTR pending list", err);
    } finally {
      setBtrPendingLoading(false);
    }
  };

  useEffect(() => {
    fetchBtrPending();
    const interval = setInterval(fetchBtrPending, 30000);
    return () => clearInterval(interval);
  }, []);

  const handleApproveBtr = async (row) => {
    try {
      await axios.put(`${AUTH_URL}api/approve_btr`, {
        query_id: row._id || row.grievance_id,
        admin_comment: "BTR approved by Admin.",
      }, { headers: { "Content-Type": "application/json" } });
      Swal.fire({ icon: "success", title: "BTR Approved!", text: `BTR for complaint ${row.grievance_id} has been approved.` });
      fetchBtrPending();
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.error || "Failed to approve BTR." });
    }
  };

  const handleRejectBtr = async () => {
    if (!btrRejectReason.trim()) {
      Swal.fire({ icon: "warning", title: "Reason Required", text: "Please provide a reason for rejection." });
      return;
    }
    try {
      await axios.put(`${AUTH_URL}api/reject_btr`, {
        query_id: btrRejectModal._id || btrRejectModal.grievance_id,
        admin_comment: btrRejectReason,
      }, { headers: { "Content-Type": "application/json" } });
      Swal.fire({ icon: "success", title: "BTR Revision Requested", text: `Officer has been notified to revise BTR for ${btrRejectModal.grievance_id}.` });
      setBtrRejectModal(null);
      setBtrRejectReason("");
      fetchBtrPending();
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.error || "Failed to reject BTR." });
    }
  };

  const calculateDaysLapsed = (row) => {
    if (!row.grievance_submission_timestamp) return 0;
    const submittedDate = new Date(row.grievance_submission_timestamp);
    const date = new Date();
    const diff = date - submittedDate;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    if (row.tat === "within 1 day") return days - 1 > 0 ? days - 1 : 0;
    if (row.tat === "2 days") return days - 2 > 0 ? days - 2 : 0;
    if (row.tat === "3 days") return days - 3 > 0 ? days - 3 : 0;
    return 0;
  };

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const [deptFilter, setDeptFilter] = useState("All");

  useEffect(() => {
    const getRating = async () => {
      try {
        const res = await axios.get(`${AUTH_URL}api/average_feedback_rating`, {
          headers: { "Content-Type": "application/json" },
        });
        setRating(res.data?.average_feedback_rating);
      } catch (error) {
        console.log("No records");
      }
    };
    getRating();
  }, []);
  // Derive counts and groupings
  const stats = useMemo(() => {
    const normalizeStatus = (status) => {
      const s = (status || "pending").toLowerCase();
      if (s === "pending") return "Pending";
      if (s === "resolved" || s === "closed") return "Resolved";
      if (s === "rejected") return "Rejected";
      if (s === "responded") return "Responded";
      return "Other";
    };

    const statusSummary = [
      {
        name: "Employee/Pensioner of IA&AD",
        value: dashboardData.officer1,
      },
      {
        name: "Complaint pertaining to State Govt. Employees/ Pensioners if pending in PAGs/AGs offices",
        value: dashboardData.officer2,
      },
    ];
    const statusCounts = {};
    const categories = {};
    const grievances = [];

    data.forEach((item) => {
      const normalizedStatus = normalizeStatus(item.status);
      statusCounts[normalizedStatus] =
        (statusCounts[normalizedStatus] || 0) + 1;

      const category = item.llm_subcategory || "Other";
      categories[category] = (categories[category] || 0) + 1;

      grievances.push({
        id: item.grievance_id.slice(0, 6) + "...",
        category,
        status: normalizedStatus,
        date: new Date(item.grievance_submission_timestamp).toLocaleDateString(
          "en-IN",
        ),
      });
    });

    const dueDatadept =
      Array.isArray(overdueData) && overdueData.length
        ? (() => {
          const aggregated = {};
          overdueData.forEach((item) => {
            const normalizedStatus = item.llm_category;
            if (!aggregated[normalizedStatus]) {
              aggregated[normalizedStatus] = {
                name: normalizedStatus,
                count: 0,
              };
            }
            aggregated[normalizedStatus].count += 1;
          });
          return Object.values(aggregated).map((item) => ({
            ...item,
          }));
        })()
        : null;

    const dueDataTat =
      Array.isArray(overdueData) && overdueData.length
        ? (() => {
          const aggregated = {};
          overdueData.forEach((item) => {
            const overdue = calculateDaysLapsed(item);
            let timeOverdue = 0;
            if (overdue >= 0 && overdue <= 1) timeOverdue = "0-1 day";
            if (overdue > 1 && overdue <= 5) timeOverdue = "2-5 days";
            if (overdue > 5 && overdue <= 10) timeOverdue = "6-10 days";
            if (overdue > 10) timeOverdue = "more than 10 days";
            if (!aggregated[timeOverdue]) {
              aggregated[timeOverdue] = { days: timeOverdue, count: 0 };
            }
            aggregated[timeOverdue].count += 1;
          });
          return Object.values(aggregated).map((item) => ({
            ...item,
          }));
        })()
        : null;

    return {
      total: data.length,
      statusPieData:
        statusSummary ??
        Object.entries(statusCounts).map(([name, value]) => ({ name, value })),
      categories: Object.entries(categories).map(([name, value]) => ({
        name,
        value,
      })),
      grievances,
      allGrievances: data,
      overdueGrievances: overdueData,
      dueDatadept,
      dueDataTat,
    };
  }, [data, dashboardData, overdueData]);

  const filteredAdminGrievances = useMemo(() => {
    let filtered = stats.allGrievances;
    filtered = filtered.filter((item) => {
      // Filter only by grievance ID
      return item.officer_name && item.officer_name.toLowerCase() === "admin";
    });

    if (sortConfig.key) {
      filtered = [...filtered].sort((a, b) => {
        let aValue, bValue;

        switch (sortConfig.key) {
          case "grievance_id":
            aValue = a.grievance_id || "";
            bValue = b.grievance_id || "";
            break;
          case "severity":
            aValue = a.severity || "";
            bValue = b.severity || "";
            break;
          case "source":
            aValue = a.source || "";
            bValue = b.source || "";
            break;
          case "reg_date":
            aValue = new Date(a.grievance_submission_timestamp || 0).getTime();
            bValue = new Date(b.grievance_submission_timestamp || 0).getTime();
            break;
          case "tat":
            aValue = a.tat || "";
            bValue = b.tat || "";
            break;
          case "days_lapsed":
            aValue = calculateDaysLapsed(a);
            bValue = calculateDaysLapsed(b);
            break;
          case "feedback_call_summary":
            aValue = a.feedback_call_summary || "";
            bValue = b.feedback_call_summary || "";
            break;
          case "feedback_call_category": {
            const getWeight = (val) => {
              if (!val) return 3;
              const v = val.toLowerCase();
              if (v.includes("very_satisfied") || v.includes("very satisfied"))
                return 1;
              if (
                v.includes("very_unsatisfied") ||
                v.includes("very unsatisfied")
              )
                return 2;
              return 3;
            };
            aValue = getWeight(a.feedback_call_category);
            bValue = getWeight(b.feedback_call_category);
            break;
          }
          default:
            return 0;
        }

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return filtered;
  }, [
    stats.allGrievances,
    stats.overdueGrievances,
    searchQuery,
    searchParam,
    sortConfig,
  ]);

  const filteredGrievances = useMemo(() => {
    let filtered = stats.allGrievances;
    if (searchQuery) {
      const lowerQuery = searchQuery.toLowerCase();
      filtered = filtered.filter((item) => {
        // Filter only by grievance ID
        return (
          item.grievance_id &&
          item.grievance_id.toLowerCase().includes(lowerQuery)
        );
      });
    }

    if (sortConfig.key) {
      filtered = [...filtered].sort((a, b) => {
        let aValue, bValue;

        switch (sortConfig.key) {
          case "grievance_id":
            aValue = a.grievance_id || "";
            bValue = b.grievance_id || "";
            break;
          case "severity":
            aValue = a.severity || "";
            bValue = b.severity || "";
            break;
          case "source":
            aValue = a.source || "";
            bValue = b.source || "";
            break;
          case "reg_date":
            aValue = new Date(a.grievance_submission_timestamp || 0).getTime();
            bValue = new Date(b.grievance_submission_timestamp || 0).getTime();
            break;
          case "tat":
            aValue = a.tat || "";
            bValue = b.tat || "";
            break;
          case "days_lapsed":
            aValue = calculateDaysLapsed(a);
            bValue = calculateDaysLapsed(b);
            break;
          case "feedback_call_summary":
            aValue = a.feedback_call_summary || "";
            bValue = b.feedback_call_summary || "";
            break;
          case "feedback_call_category": {
            const getWeight = (val) => {
              if (!val) return 3;
              const v = val.toLowerCase();
              if (v.includes("very_satisfied") || v.includes("very satisfied"))
                return 1;
              if (
                v.includes("very_unsatisfied") ||
                v.includes("very unsatisfied")
              )
                return 2;
              return 3;
            };
            aValue = getWeight(a.feedback_call_category);
            bValue = getWeight(b.feedback_call_category);
            break;
          }
          default:
            return 0;
        }

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return filtered;
  }, [
    stats.allGrievances,
    stats.overdueGrievances,
    searchQuery,
    searchParam,
    sortConfig,
  ]);

  const filteredDueGrievances = useMemo(() => {
    let result = stats.overdueGrievances || [];
    if (deptFilter !== "All") {
      result = result.filter(
        (item) =>
          item.llm_category.toLowerCase() === deptFilter.toLocaleLowerCase(),
      );
    }

    if (sortConfig.key) {
      result = [...result].sort((a, b) => {
        let aValue, bValue;

        switch (sortConfig.key) {
          case "source":
            aValue = a.source || "";
            bValue = b.source || "";
            break;
          default:
            return 0;
        }

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return result;
  }, [stats.overdueGrievances, deptFilter, sortConfig]);

  const filteredSelectedGrievances = useMemo(() => {
    let result = selectedTableData || [];
    if (deptFilter !== "All") {
      result = result.filter(
        (item) => item.llm_category.toLowerCase() === deptFilter.toLowerCase(),
      );
    }
    if (sortConfig.key) {
      result = [...result].sort((a, b) => {
        let aValue, bValue;

        switch (sortConfig.key) {
          case "source":
            aValue = a.source || "";
            bValue = b.source || "";
            break;
          default:
            return 0;
        }

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return result;
  }, [selectedTableData, deptFilter, sortConfig]);

  // Fetch pie chart percentages from the new API
  useEffect(() => {
    const fetchPieChartData = async () => {
      try {
        if (data && data.length > 0) {
          const userId = data[0].user_id;
          if (userId) {
            const res = await axios.get(
              `${AUTH_URL}api/pendingrespondedpercentageuser?user_id=${userId}`,
            );
            if (res.data && res.data.success) {
              setPieChartData({
                pending: {
                  count: res.data.pending_count,
                  percentage: res.data.pending_percentage,
                },
                responded: {
                  count: res.data.responded_count,
                  percentage: res.data.responded_percentage,
                },
                total: res.data.total_grievances,
              });
            }
          }
        }
      } catch (error) {
        console.error("Error fetching pie chart data:", error);
      }
    };

    fetchPieChartData();
  }, [data]);
  const handleEditClick = (item) => {
    setSelectedRow(item);
    setIsViewOnly(getOfficerGrievanceStatus(item) === "Resolved");
    setIsAdminModalOpen(true);
  };
  const resetAdminModalState = () => {
    setAtrFile(null);
    setAtrSummary("");
    setAtrFileUrl("");
    setBtrMode(null);
    setBtrContent("");
    setBtrFile(null);
    setBtrFileUrl("");
    setBtrSummary("");
    setAiSummaryOpen(false);
  };

  const handleAdminViewClick = async (item) => {
    resetAdminModalState();
    const res = await getGrievance(item.grievance_id);
    const grievanceObj = res || item;
    if (grievanceObj) {
      setSelectedRow(grievanceObj);
      setIsViewOnly(getOfficerGrievanceStatus(grievanceObj) === "Resolved");
      setIsAdminModalOpen(true);
    }
  };

  const handleViewClick = async (item) => {
    resetAdminModalState();
    const res = await getGrievance(item.grievance_id);
    const grievanceObj = res || item;
    if (grievanceObj) {
      setSelectedRow(grievanceObj);
      setIsViewOnly(getOfficerGrievanceStatus(grievanceObj) === "Resolved");
      setIsAdminModalOpen(true);
    }
  };
  const handleViewATR = (item) => {
    setSelectedRow(item);
    setIsViewOnly(true); // Set view-only mode
    setIsATROpen(true);
  };

  const handleCloseATR = () => {
    setIsATROpen(false);
    setSelectedRow(null);
  };
  const handleViewFeedback = (item) => {
    setSelectedRow(item);
    setIsViewOnly(true); // Set view-only mode
    setIsFeedbackOpen(true);
  };

  const handleCloseFeedback = () => {
    setIsFeedbackOpen(false);
    setSelectedRow(null);
  };

  const handleCloseComment = () => {
    setIsCommentOpen(false);
    setSelectedRow(null);
  };
  const handleClose = () => {
    setIsModalOpen(false);
    setIsAdminModalOpen(false);
    setSelectedRow(null);
    setAiSummaryOpen(false);
    setAiSummaryText("");
    setBtrMode(null);
    setBtrContent("");
    setBtrFile(null);
    setBtrFileUrl("");
    setBtrSummary("");
  };

  const handleGenerateBtr = async () => {
    if (!selectedRow) return;
    setBtrLoading(true);
    setBtrMode("generate");
    try {
      const dataRes = await axios.post(`${AUTH_URL}api/generate_btr`, {
        grievance_id: selectedRow.grievance_id,
      }, { headers: { "Content-Type": "application/json" } });

      const gData = dataRes.data.grievance_data;
      const llmRes = await axios.post(`${CHAT_URL}v1/generate_btr_content`, gData, {
        headers: { "Content-Type": "application/json" },
      });
      setBtrContent(stripMarkdownFence(llmRes.data.btr_text || ""));
    } catch (err) {
      console.error("BTR generation error:", err);
      Swal.fire({ icon: "error", title: "BTR Generation Failed", text: "Could not generate BTR. Please try again." });
    } finally {
      setBtrLoading(false);
    }
  };

  const handleBtrFileUpload = async () => {
    if (!btrFile) return;
    setBtrLoading(true);
    const formData = new FormData();
    formData.append("uploaded_file", btrFile);
    try {
      const res = await axios.post(`${CHAT_URL}v1/upload_btr_file`, formData, {
        headers: {
          accept: "application/json",
          "x-source": "12",
          "x-consumer-id": "12",
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.status === 200 && res.data) {
        const cleanSummary = stripMarkdownFence(res.data.summary || "");
        setBtrFileUrl(res.data.file_url || "");
        setBtrSummary(cleanSummary);
        setBtrContent(cleanSummary);
        Swal.fire({ icon: "success", title: "BTR Uploaded", text: "BTR PDF uploaded successfully." });
      }
    } catch (err) {
      Swal.fire({ icon: "error", title: "Upload Failed", text: "Could not upload BTR PDF." });
    } finally {
      setBtrLoading(false);
    }
  };

  const handleSubmitBtr = async () => {
    if (!btrContent && !btrFileUrl) {
      Swal.fire("Error", "Please generate or upload a BTR before submitting.", "error");
      return;
    }
    setBtrSubmitLoading(true);
    try {
      const res = await axios.post(`${AUTH_URL}api/submit_btr`, {
        query_id: selectedRow._id || selectedRow.grievance_id,
        btr_content: btrContent,
        btr_file_url: btrFileUrl,
        btr_summary: btrSummary || btrContent.slice(0, 300),
      }, { headers: { "Content-Type": "application/json" } });

      const finalSummary = btrSummary || btrContent;
      setSelectedRow((prev) => ({
        ...prev,
        btr_content: btrContent,
        btr_file_url: btrFileUrl,
        btr_summary: finalSummary,
        btr_status: "Attached",
        btr_timestamp: res.data?.btr_timestamp || new Date().toISOString(),
        officer_grievance_status: "Attach ATR",
        user_grievance_status: "InProgress",
      }));
      setBtrMode(null);
      setBtrContent("");

      Swal.fire({ icon: "success", title: "BTR Attached!", text: "BTR document has been attached to the complaint successfully." });
      setQueryUpdate((prev) => !prev);
    } catch (err) {
      Swal.fire({ icon: "error", title: "Submission Failed", text: err?.response?.data?.error || "Could not submit BTR." });
    } finally {
      setBtrSubmitLoading(false);
    }
  };

  const handleAiSummary = async () => {
    if (!selectedRow) return;
    setAiSummaryOpen(true);
    setAiSummaryLoading(true);
    setAiSummaryText("");
    try {
      const res = await axios.post(`${CHAT_URL}v1/generate_ai_summary`, {
        grievance_id: selectedRow.grievance_id,
        role: "admin",
      }, { headers: { "Content-Type": "application/json" } });
      setAiSummaryText(res.data.summary || "No summary available.");
    } catch (err) {
      setAiSummaryText("Could not generate summary. Please try again.");
    } finally {
      setAiSummaryLoading(false);
    }
  };

  // Inline AI Summary handler for the Complaints Over Time table
  const handleTableAiSummary = async (row) => {
    setTableAiSummaryRow(row);
    setTableAiSummaryOpen(true);
    setTableAiSummaryLoading(true);
    setTableAiSummaryText("");
    try {
      const res = await axios.post(
        `${CHAT_URL}v1/generate_ai_summary`,
        { grievance_id: row.grievance_id, role: "admin" },
        { headers: { "Content-Type": "application/json" } }
      );
      setTableAiSummaryText(res.data.summary || "No summary available.");
    } catch (err) {
      setTableAiSummaryText("Could not generate summary. Please try again.");
    } finally {
      setTableAiSummaryLoading(false);
    }
  };
  const handleLikeClick = (e) => {
    e.preventDefault();
    setIsLiked(true);
    setShowCommentArea(false); // Hide comment area after liking
  };

  const handleDislikeClick = (e) => {
    e.preventDefault();
    setIsLiked(false);
    setShowCommentArea(true); // Show comment area after disliking
  };

  const handleSave1 = async () => {
    setSaveLoading(true);
    try {
      const feedbackData = {
        grievance_id: selectedRow.id, // Assuming you have selectedRow.id for grievance ID
        feedbackrating: isLiked ? 1 : 0, // 1 for like, 0 for dislike
        feedbacktext: comment, // The comment entered by the user
      };

      const res = await axios(`${AUTH_URL}/api/feedback`, feedbackData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (res.status === 200) {
        console.log("Feedback saved successfully");
        // Optionally, reset the states after saving
        setIsLiked(false);
        setComment("");
        setShowCommentArea(false);
      }
    } catch (error) {
      console.error("Error saving feedback:", error);
    } finally {
      setSaveLoading(false);
    }
  };
  const handleViewComment = (item) => {
    setSelectedRow(item);
    setIsViewOnly(true); // Set view-only mode
    setIsCommentOpen(true);
  };

  const handleEditComment = (item) => {
    setSelectedRow(item);
    setIsViewOnly(false); // Set view-only mode
    setIsCommentOpen(true);
  };

  const handleNotifyOfficer = async (item, commentOverride) => {
    const comment = commentOverride !== undefined ? commentOverride : remindCommentText;
    try {
      const response = await axios.put(
        `${API_URL}api/admin_sendnotification_officer`,
        {
          officer_name: item.officer_name,
          grievance_id: item.grievance_id,
          admin_comment: comment || undefined,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (response) {
        setRemindedIds(prev => new Set([...prev, item.grievance_id]));
        Swal.fire({
          title: "Success",
          text: `Reminder has been sent successfully to Officer : ${toSentenceCase(item.officer)}`,
          icon: "success",
        });
      }
    } catch (error) {
      if (error.response) {
        // alert(error.response.data.message);
        Swal.fire({
          title: "Success",
          text: `${error.response.data.message}`,
          icon: "success",
        });
      } else {
        alert("We are facing issue at our end. Please try after some time.");
      }
    }
  };

  const saveAdminComment = async () => {
    try {
      const payload = {
        grievance_id: selectedRow.grievance_id,
        admincomment: adminComment,
      };

      let res = await axios.post(`${AUTH_URL}api/admin_comment`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (res.status === 200) {
        setQueryUpdate(true);
        setIsModalOpen(false);
        Swal.fire({
          title: "Feedback Saved!",
          text: "Feedback document has been saved successfully.",
          icon: "success",
        });
      }
    } catch (error) {
      console.log("Error in Update Query API", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${error?.response?.data?.error || "Error in Update Query API"}`,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSelectedRow((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const downloadPDF = () => {
    const doc = new jsPDF("landscape");

    // IMPORTANT
    doc.setFont("NotoSansDevanagari");

    // Table columns
    const columns = [
      { header: "Complaint ID", dataKey: "grievance_id" },
      { header: "User Query", dataKey: "user_query" },
      { header: "Department", dataKey: "llm_ministry" },
      { header: "Status", dataKey: "status" },
      { header: "Officer Response", dataKey: "grievance_response" },
      { header: "ATR", dataKey: "atr_summary" },
      { header: "Feedback Call", dataKey: "feedback_call_summary" },
      {
        header: "User Feedback ",
        dataKey: "user_feedback",
      },
    ];

    // Table rows
    const rows = data.map((item) => ({
      grievance_id: item.grievance_id || "",
      user_query: item.grievance_title || item.user_query || item.user_query_english || "",

      llm_ministry: item.llm_ministry || "",

      status: item.officer_grievance_status || "",

      grievance_response: item.grievance_response || "",

      atr_summary: item.atr_summary || "",

      feedback_call_summary: item.feedback_call_summary || "",

      user_feedback: item.user_grievance_feedback_comments || "",
    }));

    doc.setFontSize(16);

    doc.text("Complaint Report", 14, 15);

    autoTable(doc, {
      startY: 25,

      columns,

      body: rows,

      theme: "grid",

      styles: {
        font: "NotoSansDevanagari",
        fontSize: 7,
        overflow: "linebreak",
        cellPadding: 2,
        valign: "middle",
        halign: "left",
      },

      headStyles: {
        fillColor: [41, 128, 185],
        font: "NotoSansDevanagari",
        fontStyle: "normal",
        textColor: [255, 255, 255],
        fontSize: 8,
      },

      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },

      columnStyles: {
        grievance_id: {
          cellWidth: 25,
        },

        user_query: {
          cellWidth: 20,
        },

        llm_ministry: {
          cellWidth: 20,
        },

        status: {
          cellWidth: 20,
        },

        grievance_response: {
          cellWidth: 20,
        },

        atr_summary: {
          cellWidth: 70,
        },

        atr_category: {
          cellWidth: 15,
        },

        feedback_call_summary: {
          cellWidth: 70,
        },

        feedback_call_category: {
          cellWidth: 20,
        },
      },

      margin: {
        top: 20,
        left: 5,
        right: 5,
      },

      didDrawPage: () => {
        doc.setFontSize(10);

        doc.text(`Generated On: ${new Date().toLocaleString()}`, 220, 10);
      },
    });

    doc.save("complaint-report.pdf");
  };

  const handleBarClick = (data) => {
    if (data.name) {
      const selectedDueData = overdueData.filter(
        (item) => item.officer_name === data.name,
      );
      setSelectedTableData(selectedDueData);
    }
    if (data.days) {
      const selectedDueData = overdueData.filter((item) => {
        const overdue = calculateDaysLapsed(item);
        let timeOverdue = 0;
        if (overdue >= 0 && overdue <= 1) timeOverdue = "0-1 day";
        if (overdue > 1 && overdue <= 5) timeOverdue = "2-5 days";
        if (overdue > 5 && overdue <= 10) timeOverdue = "6-10 days";
        if (overdue > 10) timeOverdue = "more than 10 days";
        return timeOverdue === data.days;
      });
      setSelectedTableData(selectedDueData);
    }
    setTimeout(() => {
      tableRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };
  const FILE_URL_SEPARATOR = "|||FILE_URL|||";

  const decodeSummary = (raw) => {
    if (!raw) return { summary: "", fileUrl: "" };
    const parts = raw.split(FILE_URL_SEPARATOR);
    return { summary: parts[0], fileUrl: parts[1] || "" };
  };
  const handleAtrUpload = async () => {
    if (!atrFile) {
      Swal.fire("Error", "Please select a file to upload", "error");
      return;
    }
    const formData = new FormData();
    formData.append("uploaded_file", atrFile);

    try {
      setAtrUploadLoading(true);
      const res = await axios.post(
        `${CHAT_URL}v1/categorize_atr_file`,
        formData,
        {
          headers: {
            accept: "application/json",
            "x-source": "12",
            "x-consumer-id": "12",
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (res.status === 200 && res.data) {
        setAtrSummary(res.data.summary);
        setAtrFileUrl(res.data.file_url);
        Swal.fire({
          title: "Success!",
          text: "ATR Document uploaded and analyzed successfully.",
          icon: "success",
        });
      }
    } catch (error) {
      console.log("Error uploading ATR:", error);
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: "Could not upload the ATR document.",
      });
    } finally {
      setAtrUploadLoading(false);
    }
  };
  const handleATR = async (grievanceId) => {
    const fileUrl =
      selectedRow?.atr_file_url ||
      decodeSummary(selectedRow?.atr_summary).fileUrl ||
      (atrFileUrl && selectedRow?.atr_uploaded ? atrFileUrl : "");

    if (fileUrl) {
      window.open(fileUrl, "_blank");
      return;
    }

    const atrText = decodeSummary(selectedRow?.atr_summary).summary || selectedRow?.atr_summary;
    if (atrText) {
      const blob = new Blob([atrText], { type: "text/plain;charset=utf-8;" });
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = `ATR_${grievanceId || "report"}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
      return;
    }

    Swal.fire({
      icon: "info",
      title: "No ATR File",
      text: "No ATR document or summary is available for download.",
    });
  };

  const handleAudioUpload = async () => {
    if (!audioFile) {
      Swal.fire("Error", "Please select an audio file to upload", "error");
      return;
    }
    const formData = new FormData();
    formData.append("uploaded_file", audioFile);

    try {
      setAudioUploadLoading(true);
      const res = await axios.post(`${CHAT_URL}v1/upload_file`, formData, {
        headers: {
          accept: "application/json",
          "x-source": "787",
          "x-consumer-id": "878",
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.status === 200 && res.data) {
        setAudioSummary(res.data.summary);
        setAudioFileUrl(res.data.file_url);
        setResponse(res.data.response);
        Swal.fire({
          title: "Success!",
          text: "Audio file uploaded and analyzed successfully.",
          icon: "success",
        });
      }
    } catch (error) {
      console.log("Error uploading audio:", error);
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: "Could not upload the audio file.",
      });
    } finally {
      setAudioUploadLoading(false);
    }
  };

  const encodeSummaryWithUrl = (summary, fileUrl) => {
    if (!fileUrl) return summary;
    return `${summary}${FILE_URL_SEPARATOR}${fileUrl}`;
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      const isAlreadyResponded =
        selectedRow?.officer_grievance_status?.toLowerCase() !== "add comment";

      if (isAlreadyResponded) {
        let summaryToSave = "";
        let urlToSave = "";
        let url = "";
        let payload = null;
        // If already responded, we are just saving the ATR via update_atr
        if (!selectedRow.atr_uploaded) {
          summaryToSave =
            atrSummary || decodeSummary(selectedRow.atr_summary).summary;
          urlToSave =
            atrFileUrl || decodeSummary(selectedRow.atr_summary).fileUrl;
          url = "update_atr";
          payload = {
            query_id: selectedRow._id,
            summary: encodeSummaryWithUrl(summaryToSave, urlToSave),
            status: "Resolved",
          };
        } else {
          summaryToSave =
            audioSummary ||
            decodeSummary(selectedRow.feedback_call_summary).summary;
          urlToSave =
            audioFileUrl || decodeSummary(selectedRow.atr_summary).summary;
          url = "update_feedback";
          payload = {
            query_id: selectedRow._id,
            summary: encodeSummaryWithUrl(summaryToSave, urlToSave),
            feedback: response,
          };
        }

        let res = await axios.put(`${AUTH_URL}api/${url}`, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (res.status === 200) {
          setSelectedRow((prev) => ({
            ...prev,
            atr_uploaded: true,
            atr_summary: summaryToSave,
            atr_file_url: urlToSave,
            officer_grievance_status: "Resolved",
            user_grievance_status: "Resolved",
          }));
          setQueryUpdate(true);
          setIsModalOpen(false);
          setIsAdminModalOpen(false);
          setAtrFile(null);
          setAtrSummary("");
          setAtrFileUrl("");
          if (url === "update_feedback") {
            Swal.fire({
              title: "Audio Saved!",
              text: "Audio document has been saved successfully.",
              icon: "success",
            });
          } else {
            Swal.fire({
              title: "ATR Saved!",
              text: "ATR document has been saved successfully.",
              icon: "success",
            });
          }
        }
      } else {
        // Normal response save for pending grievances
        const comments =
          selectedRow.officer_grievance_comments ||
          selectedRow.grievance_response ||
          "";
        const isResponded = comments.trim().length > 0;

        const payload = {
          query_id: selectedRow._id,
          officer_grievance_comments: comments,
          atr_uploaded: false,
        };

        if (isResponded) {
          payload.status = "Responded";
        }

        let res = await axios.put(
          `${AUTH_URL}api/grievance_response`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (res.status === 200) {
          setQueryUpdate(true);
          setIsModalOpen(false);
          setAtrFile(null);
          setAtrSummary("");
          setAtrFileUrl("");
          Swal.fire({
            title: "Query Updated!",
            text: "You have successfully updated.",
            icon: "success",
          });
        }
      }
    } catch (error) {
      console.log("Error in Update Query API", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${error?.response?.data?.error || "Error in Update Query API"}`,
      });
    } finally {
      setLoading(false);
      setIsAdminModalOpen(false);
    }
  };

  return (
    <div className="w-full bg-[#f4f7f9] min-h-screen p-5 sm:p-7 font-sans">
      <div className="max-w-[1600px] mx-auto">
        <h2 className="text-[20px] font-[700] text-[#0e2f4d] mb-5">
          Admin Analytics Dashboard
        </h2>

        {/* Row 1: Category & Sub-Category Charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-6">
          <div className="card flex flex-col h-[400px]">
            <h3 className="font-[700] text-[16px] text-[#0e2f4d] mb-3">
              Complaint By Categories
            </h3>
            <div className="flex-1 min-h-0">
              <PieCharts
                data={
                  stats.categories && stats.categories.length > 0
                    ? stats.categories.map((c) => ({ name: c.name, value: c.value }))
                    : []
                }
                nameKey="name"
                dataKey="value"
                innerRadius="45%"
                colors={[
                  "#0e2f4d",
                  "#008080",
                  "#e07a2c",
                  "#8A6CCF",
                  "#D07A5C",
                  "#5DADE2",
                ]}
              />
            </div>
          </div>

          <div className="card flex flex-col h-[400px]">
            <h3 className="font-[700] text-[16px] text-[#0e2f4d] mb-3">
              Top Sub-Categories of Complaints
            </h3>
            <div className="flex-1 min-h-0">
              <BarCharts
                data={
                  dashboardData.summary && dashboardData.summary.length > 0
                    ? dashboardData.summary
                    : []
                }
                nameKey="name"
                xAxisName="Number of Complaints"
                colors={[
                  "#0e2f4d",
                  "#008080",
                  "#e07a2c",
                  "#3B82C4",
                  "#8A6CCF",
                  "#D07A5C",
                ]}
              />
            </div>
          </div>
        </div>

        {/* Row 2: User Satisfaction + All Overdue Complaints Table */}
        <div className="grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-5 mb-6">
          <div className="card flex flex-col items-center justify-center p-5">
            <SatisfactionGauge value={rating || 5} />
          </div>

          <div className="card overflow-hidden flex flex-col">
            <h3 className="font-[700] text-[16px] text-[#0e2f4d] mb-3">
              All Overdue Complaints
            </h3>
            <div className="flex items-center gap-3 mb-3">
              <label className="text-[12.5px] text-[#4c6478] font-[600]">
                Department
              </label>
              <select
                id="admin-overdue-dept-filter"
                value={deptFilter}
                onChange={(e) => setDeptFilter(e.target.value)}
                className="border border-gray-300 rounded px-3 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-teal-500 bg-white"
              >
                <option value="All">All</option>
                <option value="Complaint & Investigation Cell">
                  Complaint & Investigation Cell (C&I Cell)
                </option>
              </select>
            </div>

            <div className="overflow-x-auto max-h-[320px] overflow-y-auto">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>S. No.</th>
                    <th
                      className="cursor-pointer"
                      onClick={() => requestSort("grievance_id")}
                    >
                      Complaint ID <i className="fa-solid fa-sort ml-1"></i>
                    </th>

                    <th>User Complaint</th>
                    <th>Department</th>
                    <th>Category</th>
                    <th>Officer</th>
                    <th
                      className="cursor-pointer"
                      onClick={() => requestSort("days_lapsed")}
                    >
                      Days Overdue <i className="fa-solid fa-sort ml-1"></i>
                    </th>
                    <th>Send Reminder</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredDueGrievances.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center text-gray-500 py-4">
                        No overdue complaints.
                      </td>
                    </tr>
                  ) : (
                    filteredDueGrievances.map((row, idx) => (
                      <tr key={idx} className="hover:bg-gray-50 transition">
                        <td className="text-center text-gray-500 text-xs">{idx + 1}</td>
                        <td
                          className="font-semibold text-teal-700 cursor-pointer text-xs"
                          onClick={() => handleViewClick(row)}
                        >
                          {row.grievance_id || `NCW-2024-${88401 + idx}`}
                        </td>
                        <td className="text-xs max-w-[200px] truncate" title={row.user_query || row.grievance_title}>
                          {row.user_query || row.grievance_title || "Complaint regarding delay"}
                        </td>
                        <td className="text-xs whitespace-normal break-words min-w-[150px]">
                          Ministry of Women and Child Development
                        </td>
                        <td className="text-xs whitespace-normal break-words min-w-[150px]">
                          {row.llm_subcategory || "Other"}
                        </td>
                        <td className="text-xs">
                          {toSentenceCase(row.officer || row.officer_name || "Rajesh Kumar")}
                        </td>
                        <td className="text-xs font-bold text-[#e07a2c]">
                          {calculateDaysLapsed(row) || row.overdue || row.days_overdue || 4}
                        </td>
                        <td className="text-center">
                          <button
                            className="bg-[#4a0e1e] hover:bg-[#9c2942] text-white text-xs font-bold px-3 py-1.5 rounded transition cursor-pointer"
                            onClick={() => handleNotifyOfficer(row)}
                          >
                            Remind
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Row 3: Overdue Complaints by Categories & Overdue Days */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-6">
          <div className="card flex flex-col h-[400px]">
            <h3 className="font-[700] text-[16px] text-[#0e2f4d] mb-3">
              Overdue Complaints by Categories
            </h3>
            <div className="flex-1 min-h-0">
              <PieCharts
                data={
                  stats.dueDatadept && stats.dueDatadept.length > 0
                    ? stats.dueDatadept
                    : []
                }
                nameKey="name"
                dataKey="count"
                innerRadius="45%"
                colors={[
                  "#e07a2c",
                  "#0e2f4d",
                  "#008080",
                  "#8A6CCF",
                  "#D07A5C",
                ]}
                onBarClick={handleBarClick}
              />
            </div>
          </div>

          <div className="card flex flex-col h-[400px]">
            <h3 className="font-[700] text-[16px] text-[#0e2f4d] mb-3">
              Complaints by Overdue Days
            </h3>
            <div className="flex-1 min-h-0">
              <BarCharts
                data={
                  stats.dueDataTat && stats.dueDataTat.length > 0
                    ? stats.dueDataTat
                    : []
                }
                nameKey="days"
                xAxisName="Number of Complaints"
                xAxisHeight={35}
                colors={[
                  "#008080",
                  "#3B82C4",
                  "#e07a2c",
                  "#D07A5C",
                ]}
                onBarClick={handleBarClick}
              />
            </div>
          </div>
        </div>

        {/* Row 4: Escalated Complaints */}
        <div className="card mb-6">
          <h3 className="font-[700] text-[16px] text-[#0e2f4d] mb-3">
            Escalated Complaints
          </h3>
          <input
            type="text"
            className="search-bar"
            placeholder="Search by Complaint ID..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <div className="overflow-x-auto max-h-[340px] overflow-y-auto">
            <table className="data-table">
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th className="cursor-pointer" onClick={() => requestSort("grievance_id")}>
                    Complaint ID <i className="fa-solid fa-sort ml-1"></i>
                  </th>

                  <th>User Complaint</th>
                  <th className="cursor-pointer" onClick={() => requestSort("llm_category")}>
                    Department <i className="fa-solid fa-sort ml-1"></i>
                  </th>
                  <th>Status</th>
                  <th className="cursor-pointer" onClick={() => requestSort("reg_date")}>
                    Reg. Date <i className="fa-solid fa-sort ml-1"></i>
                  </th>
                  <th className="cursor-pointer" onClick={() => requestSort("days_lapsed")}>
                    Days Overdue <i className="fa-solid fa-sort ml-1"></i>
                  </th>
                  <th className="cursor-pointer" onClick={() => requestSort("tat")}>
                    TAT % <i className="fa-solid fa-sort ml-1"></i>
                  </th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredAdminGrievances.length === 0 ? (
                  <tr>
                    <td colSpan="10" className="text-center text-gray-500 py-4">
                      No escalated complaints found.
                    </td>
                  </tr>
                ) : (
                  filteredAdminGrievances.map((row, idx) => (
                    <tr key={idx} className="hover:bg-gray-50 transition">
                      <td className="text-center text-gray-500 text-xs">{idx + 1}</td>
                      <td
                        className="font-semibold text-teal-700 cursor-pointer text-xs"
                        onClick={() => handleAdminViewClick(row)}
                      >
                        {row.grievance_id || `NCW-2024-${88401 + idx}`}
                      </td>
                      <td className="text-xs max-w-[220px] truncate" title={row.user_query || row.grievance_title}>
                        {row.user_query || row.grievance_title}
                      </td>
                      <td className="text-xs whitespace-normal break-words min-w-[150px]">
                        {row.llm_category || "Complaint & Investigation Cell"}
                      </td>
                      <td className="text-xs">
                        {(() => {
                          const st = getOfficerGrievanceStatus(row);
                          const cls =
                            st === "Resolved" ? "bg-green-100 text-green-800" :
                            st === "BTR Rejected" ? "bg-red-100 text-red-800" :
                            st === "BTR Under Review" ? "bg-amber-100 text-amber-800" :
                            st === "Attach ATR" ? "bg-blue-100 text-blue-800" :
                            "bg-gray-100 text-gray-700";
                          return <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-semibold ${cls}`}>{st}</span>;
                        })()}
                      </td>
                      <td className="text-xs whitespace-nowrap">
                        {new Date(row.grievance_submission_timestamp || "2024-05-14").toLocaleDateString("en-IN")}
                      </td>
                      <td className="text-xs font-bold text-[#e07a2c]">
                        {calculateDaysLapsed(row) || row.overdue || row.days_overdue || 4}
                      </td>
                      <td className="text-xs">{row.tat || "15 days"}</td>
                      <td className="text-center">
                        <button
                          className="w-8 h-8 rounded-full bg-teal-50 hover:bg-teal-100 text-teal-700 flex items-center justify-center mx-auto transition cursor-pointer"
                          onClick={() => handleAdminViewClick(row)}
                          title="View Complaint Details"
                        >
                          <VisibilityIcon fontSize="small" />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* BTR Pending for Approval Table */}
        <div className="card mb-6" style={{ border: '2px solid #4f46e5' }}>
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-[700] text-[16px] text-indigo-800 flex items-center gap-2">
              <i className="fa-solid fa-file-contract text-indigo-600"></i>
              BTR Pending for Approval or Rejection
              {btrPendingList.length > 0 && (
                <span className="ml-2 px-2.5 py-0.5 bg-indigo-100 text-indigo-700 text-xs font-bold rounded-full">{btrPendingList.length}</span>
              )}
            </h3>
            <button onClick={fetchBtrPending} className="text-xs text-indigo-600 hover:text-indigo-800 font-semibold flex items-center gap-1">
              <i className="fa-solid fa-rotate-right"></i> Refresh
            </button>
          </div>
          <div className="overflow-x-auto max-h-[340px] overflow-y-auto">
            <table className="data-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Complaint ID</th>
                  <th>Submitted By</th>
                  <th>Department</th>
                  <th>Category</th>
                  <th>Status</th>
                  <th>Severity</th>
                  <th>Submission Date</th>
                  <th>BTR Summary</th>
                  <th>Comment</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {btrPendingLoading ? (
                  <tr><td colSpan="11" className="text-center py-6 text-gray-500"><i className="fa-solid fa-spinner fa-spin mr-2"></i>Loading BTR submissions...</td></tr>
                ) : btrPendingList.length === 0 ? (
                  <tr><td colSpan="11" className="text-center py-6 text-gray-400"><i className="fa-regular fa-folder-open mr-2"></i>No BTRs pending for approval.</td></tr>
                ) : (
                  btrPendingList.map((row, idx) => (
                    <tr key={row._id || idx} className="hover:bg-indigo-50/40 transition">
                      <td className="text-center text-gray-500 text-xs">{idx + 1}</td>
                      <td className="font-semibold text-indigo-700 text-xs">{row.grievance_id}</td>
                      <td className="text-xs">{toSentenceCase(row.officer_name) || "—"}</td>
                      <td className="text-xs whitespace-normal break-words min-w-[140px]">Ministry of Women and Child Development</td>
                      <td className="text-xs">{row.llm_subcategory || "—"}</td>
                      <td className="text-xs">
                        <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 font-semibold text-xs">Under Review</span>
                      </td>
                      <td className="text-xs">
                        <span className={`px-2 py-0.5 rounded text-xs font-semibold ${
                          (row.severity || "").toLowerCase() === "critical" ? "bg-red-100 text-red-700" :
                          (row.severity || "").toLowerCase() === "high" ? "bg-orange-100 text-orange-700" :
                          "bg-blue-100 text-blue-700"
                        }`}>{row.severity || "—"}</span>
                      </td>
                      <td className="text-xs whitespace-nowrap">{row.btr_timestamp ? new Date(row.btr_timestamp).toLocaleDateString("en-IN") : "—"}</td>
                      <td className="text-xs max-w-[220px]">
                        {row.btr_summary || row.btr_content ? (
                          <div>
                            <p className="line-clamp-3 text-gray-700 text-xs leading-relaxed">
                              {stripMarkdown(row.btr_summary || row.btr_content || "")}
                            </p>
                            <button
                              className="text-indigo-500 hover:text-indigo-800 text-[10px] font-semibold mt-0.5 underline"
                              onClick={() => setBtrDetailModal(row)}
                            >
                              View full BTR
                            </button>
                          </div>
                        ) : <span className="text-gray-400">—</span>}
                      </td>
                      <td className="text-xs text-gray-500 max-w-[120px] truncate" title={row.btr_admin_comment || ""}>
                        {row.btr_admin_comment || "—"}
                      </td>
                      <td className="text-center">
                        <div className="flex gap-1.5 justify-center">
                          <button
                            onClick={() => handleApproveBtr(row)}
                            className="px-2.5 py-1 bg-green-600 hover:bg-green-700 text-white text-xs font-bold rounded transition cursor-pointer"
                          >
                            ✓ Approve
                          </button>
                          <button
                            onClick={() => { setBtrRejectModal(row); setBtrRejectReason(""); }}
                            className="px-2.5 py-1 bg-red-600 hover:bg-red-700 text-white text-xs font-bold rounded transition cursor-pointer"
                          >
                            ✗ Revise
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Row 5: Complaints Over Time */}
        <div className="card mb-6">
          <h3 className="font-[700] text-[16px] text-[#0e2f4d] mb-3">
            Complaints Over Time
          </h3>
          <input
            type="text"
            className="search-bar"
            placeholder="Search by Complaint ID..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <div className="overflow-x-auto max-h-[340px] overflow-y-auto">
            <table className="data-table">
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th className="cursor-pointer" onClick={() => requestSort("grievance_id")}>
                    Complaint ID <i className="fa-solid fa-sort ml-1"></i>
                  </th>

                  <th>User Complaint</th>
                  <th className="cursor-pointer" onClick={() => requestSort("llm_category")}>
                    Department <i className="fa-solid fa-sort ml-1"></i>
                  </th>
                  <th>Status</th>
                  <th>Officer Response</th>
                  <th>ATR</th>
                  <th>BTR</th>
                  <th className="cursor-pointer" onClick={() => requestSort("reg_date")}>
                    Reg. Date <i className="fa-solid fa-sort ml-1"></i>
                  </th>
                  <th className="cursor-pointer" onClick={() => requestSort("tat")}>
                    TAT <i className="fa-solid fa-sort ml-1"></i>
                  </th>
                  <th className="cursor-pointer" onClick={() => requestSort("days_lapsed")}>
                    Days Overdue <i className="fa-solid fa-sort ml-1"></i>
                  </th>
                  <th>Send Reminder</th>
                  <th className="text-center">AI Summary</th>
                </tr>
              </thead>
              <tbody>
                {filteredGrievances.length === 0 ? (
                  <tr>
                    <td colSpan="15" className="text-center text-gray-500 py-4">
                      No complaints found.
                    </td>
                  </tr>
                ) : (
                  filteredGrievances.map((row, idx) => (
                    <tr key={idx} className="hover:bg-gray-50 transition">
                      <td className="text-center text-gray-500 text-xs">{idx + 1}</td>
                      <td
                        className="font-semibold text-teal-700 cursor-pointer text-xs"
                        onClick={() => handleViewClick(row)}
                      >
                        <div className="flex items-center gap-1">
                          {row.grievance_id || `NCW-2024-${88401 + idx}`}
                          {remindedIds.has(row.grievance_id) && (
                            <i className="fa-solid fa-bell text-amber-500 text-[10px]" title="Reminder sent"></i>
                          )}
                        </div>
                      </td>
                      <td className="text-xs max-w-[180px] truncate" title={row.user_query || row.grievance_title}>
                        {row.user_query || row.grievance_title}
                      </td>
                      <td className="text-xs whitespace-normal break-words min-w-[150px]">
                        {row.llm_category || "Complaint & Investigation Cell"}
                      </td>
                      <td className="text-xs">
                        {(() => {
                          const st = getOfficerGrievanceStatus(row);
                          const cls =
                            st === "Resolved" ? "bg-green-100 text-green-800" :
                            st === "BTR Rejected" ? "bg-red-100 text-red-800" :
                            st === "BTR Under Review" ? "bg-amber-100 text-amber-800" :
                            st === "Attach ATR" ? "bg-blue-100 text-blue-800" :
                            "bg-gray-100 text-gray-700";
                          return <span className={`inline-block px-2 py-0.5 rounded text-xs font-semibold ${cls}`}>{st}</span>;
                        })()}
                      </td>
                      <td className="text-xs max-w-[150px] truncate" title={row.grievance_response || ""}>
                        {row.grievance_response || "Investigation in progress"}
                      </td>
                      <td className="text-xs relative">
                          {row.atr_summary ? (
                            <button
                              type="button"
                              className="cursor-pointer underline decoration-dotted text-teal-700 font-medium hover:text-teal-900 text-left"
                              onClick={() => setAtrPopover({ text: decodeSummary(row.atr_summary).summary || row.atr_summary })}
                            >
                              ATR Attached
                            </button>
                          ) : (
                            <span className="text-gray-400">ATR requested</span>
                          )}
                        </td>
                        <td className="text-xs">
                          <TruncatedText text={stripMarkdown(row.btr_summary ? decodeSummary(row.btr_summary)?.summary || row.btr_summary : row.btr_content || "—")} limit={20} />
                        </td>
                      <td className="text-xs whitespace-nowrap">
                        {new Date(row.grievance_submission_timestamp || "2024-05-14").toLocaleDateString("en-IN")}
                      </td>
                      <td className="text-xs">{row.tat || "15 days"}</td>
                      <td className="text-xs font-bold text-[#e07a2c]">
                        {calculateDaysLapsed(row) || row.overdue || row.days_overdue || 0}
                      </td>
                      <td className="text-center min-w-[160px]">
                        {remindCommentRow?.grievance_id === row.grievance_id ? (
                          <div className="flex flex-col gap-1">
                            <textarea
                              rows={2}
                              className="w-full text-xs border border-gray-300 rounded p-1 resize-none focus:outline-none focus:ring-1 focus:ring-[#4a0e1e]"
                              placeholder="Add comment (optional)..."
                              value={remindCommentText}
                              onChange={e => setRemindCommentText(e.target.value)}
                            />
                            <div className="flex gap-1 justify-end">
                              <button
                                className="text-xs text-gray-500 hover:text-gray-700 px-2 py-0.5 border rounded"
                                onClick={() => { setRemindCommentRow(null); setRemindCommentText(""); }}
                              >Cancel</button>
                              <button
                                className="bg-[#4a0e1e] hover:bg-[#9c2942] text-white text-xs font-bold px-2 py-0.5 rounded transition cursor-pointer"
                                onClick={() => { handleNotifyOfficer(row, remindCommentText); setRemindCommentRow(null); setRemindCommentText(""); }}
                              >Send</button>
                            </div>
                          </div>
                        ) : (
                          <button
                            className="bg-[#4a0e1e] hover:bg-[#9c2942] text-white text-xs font-bold px-3 py-1 rounded transition cursor-pointer"
                            onClick={() => { setRemindCommentRow(row); setRemindCommentText(""); }}
                          >
                            Remind
                          </button>
                        )}
                      </td>
                      <td className="text-center">
                        <button
                          className="inline-flex items-center gap-1 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white text-xs font-bold px-3 py-1 rounded-lg shadow-sm transition cursor-pointer whitespace-nowrap"
                          onClick={() => handleTableAiSummary(row)}
                          title="Generate AI Summary for this complaint"
                        >
                          <AutoAwesomeIcon style={{ fontSize: 13 }} />
                          AI Summary
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <div className="flex justify-end mt-4">
            <button
              onClick={downloadPDF}
              className="bg-[#0e2f4d] hover:bg-[#1e456c] text-white px-4 py-2 rounded text-xs font-bold transition flex items-center gap-2 cursor-pointer"
            >
              <i className="fa-solid fa-file-pdf"></i> Download PDF
            </button>
          </div>
        </div>
      </div>
      {/* <div className='h-[70vh] w-full mt-4'>
        <iframe
          src="https://sea-lion-app-xp7yb.ondigitalocean.app/feedback"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="Feedback"
        />
      </div> */}
      {/* Modal */}
      <div className="bg-white  w-full">
        {isATROpen && selectedRow && (
          <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white w-[95vw] sm:w-[80vw] max-w-4xl p-5 sm:p-6 rounded shadow-lg max-h-[85vh] overflow-auto">
              <h3 className="text-lg font-bold mb-4">View ATR</h3>
              <form className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    ATR Summary
                  </label>
                  <textarea
                    type="text"
                    name="llm_response_desc"
                    value={selectedRow.atr_summary}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={5} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>
                <div className="flex justify-end space-x-4">
                  <button
                    type="button"
                    className="px-2 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                    onClick={handleCloseATR}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        {isFeedbackOpen && selectedRow && (
          <div className="fixed inset-0 z-[9999] flex items-start sm:items-center justify-center bg-black bg-opacity-50 p-4 sm:p-0">
            <div className="bg-white w-full sm:w-[80vw] max-w-4xl p-5 sm:p-6 rounded shadow-lg max-h-[85vh] sm:max-h-[85vh] overflow-auto mt-6 sm:mt-0">
              <h3 className="text-lg font-bold mb-4">View Feedback</h3>
              <form className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Feedback Summary
                  </label>
                  <textarea
                    type="text"
                    name="llm_response_desc"
                    value={selectedRow.feedback_call_summary}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={5} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>
                <div className="flex justify-end space-x-4">
                  <button
                    type="button"
                    className="px-2 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                    onClick={handleCloseFeedback}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {isCommentOpen && selectedRow && (
          <div className="fixed inset-0 z-[9999] flex items-start sm:items-center justify-center bg-black bg-opacity-50 p-4 sm:p-0">
            <div className="bg-white w-full sm:w-[80vw] max-w-4xl p-5 sm:p-6 rounded shadow-lg max-h-[85vh] sm:max-h-[85vh] overflow-auto mt-6 sm:mt-0">
              <h3 className="text-lg font-bold mb-4">View Feedback</h3>
              <form className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Comment Summary
                  </label>
                  <textarea
                    type="text"
                    name="llm_response_desc"
                    value={adminComment || selectedRow.admin_feedback}
                    readOnly={isViewOnly}
                    onChange={(e) => setAdminComment(e.target.value)}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={5} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>
                <div className="flex justify-end space-x-4">
                  <button
                    type="button"
                    className="px-2 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                    onClick={handleCloseComment}
                  >
                    Close
                  </button>

                  {adminComment && (
                    <button
                      type="button"
                      className="px-2 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                      onClick={saveAdminComment}
                    >
                      {loading ? "Saving..." : "Save"}
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        )}
        {isAdminModalOpen && selectedRow && (
          <div className="fixed inset-0 z-[9999] flex items-start sm:items-center justify-center bg-black bg-opacity-50 p-4 sm:p-0">
            <div className="bg-white w-full sm:w-[80vw] max-w-4xl p-5 sm:p-6 rounded shadow-lg max-h-[85vh] sm:max-h-[90vh] overflow-auto mt-6 sm:mt-0">
              <h3 className="text-lg font-bold mb-4">Complaint Summary</h3>
              <form className="space-y-4">
                {/* Query Title */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    User Complaint
                  </label>
                  <input
                    type="text"
                    name="user_query"
                    value={selectedRow.user_query}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Bot Response
                  </label>
                  <textarea
                    name="llm_response_desc"
                    value={selectedRow.llm_response_desc}
                    // onChange={handleInputChange}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={3} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Comment from Officer
                  </label>
                  <textarea
                    name="officer_grievance_comments"
                    value={
                      selectedRow?.officer_transfer_comments ||
                      selectedRow?.grievance_response
                    }
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={3} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>
                {/* Response from expert */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Comment from Admin
                  </label>
                  <textarea
                    name="officer_grievance_comments"
                    value={
                      selectedRow?.officer_grievance_comments ||
                      selectedRow?.grievance_response
                    }
                    onChange={handleInputChange}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={3} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>

                {/* <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Ministry
                  </label>
                  <input
                    type="text"
                    name="llm_ministry"
                    value={selectedRow.llm_ministry}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div> */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Department
                  </label>
                  <input
                    type="text"
                    name="llm_category"
                    value={selectedRow.llm_category}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Sub Category
                  </label>
                  <input
                    type="text"
                    name="llm_subcategory"
                    value={selectedRow.llm_subcategory}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    State
                  </label>
                  <input
                    type="text"
                    name="state"
                    value={selectedRow.state || ""}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    District
                  </label>
                  <input
                    type="text"
                    name="district"
                    value={selectedRow.district}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Severity
                  </label>
                  <input
                    type="text"
                    name="severity"
                    value={selectedRow.severity}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    User Id
                  </label>
                  <input
                    type="text"
                    name="user_id"
                    value={selectedRow.user_id}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                  />
                </div>

                {/* SECTION 1: Brief Transmission Report (BTR) — Always displayed first */}
                <div className="bg-blue-50/70 p-4 rounded-xl border border-blue-200 mt-4 shadow-xs">
                  <h4 className="text-md font-bold text-indigo-900 mb-3 flex items-center gap-1.5">
                    📋 Brief Transmission Report (BTR)
                  </h4>

                  {/* If BTR is already Attached OR status is 'Attach ATR' / 'Resolved' */}
                  {(selectedRow.btr_status === "Attached" ||
                    (selectedRow.btr_status && selectedRow.btr_status !== "None") ||
                    selectedRow.btr_file_url ||
                    selectedRow.btr_content ||
                    selectedRow.btr_summary ||
                    getOfficerGrievanceStatus(selectedRow) === "Attach ATR" ||
                    getOfficerGrievanceStatus(selectedRow) === "Resolved" ||
                    selectedRow.atr_uploaded) ? (
                    <div>
                      <div className="flex items-center justify-between bg-white p-3 rounded-lg border border-indigo-100 mb-3">
                        <div className="flex items-center gap-2">
                          <span className="px-2.5 py-1 bg-green-100 text-green-800 font-semibold text-xs rounded-full">
                            BTR Attached
                          </span>
                          {selectedRow.btr_timestamp && (
                            <span className="text-xs text-slate-500">
                              Attached on {new Date(selectedRow.btr_timestamp).toLocaleDateString("en-IN")}
                            </span>
                          )}
                        </div>
                      </div>

                      {/* Prefilled BTR Summary / Content Display */}
                      {btrMode !== "edit" && (
                        <div className="mt-3 bg-white p-3 rounded-lg border border-indigo-100">
                          <label className="block text-xs font-bold text-indigo-900 uppercase mb-1">
                            BTR Summary / Case Scope
                          </label>
                          <FormattedMarkdown
                            content={
                              getBtrText(selectedRow) ||
                              `**Brief Transmission Report (BTR)** was attached for Police Escalation for grievance **${selectedRow.grievance_id || ""}**.`
                            }
                          />
                        </div>
                      )}

                      {/* BTR Actions for Admin */}
                      {!btrMode && (selectedRow.btr_file_url || btrFileUrl || selectedRow.btr_content || selectedRow.btr_summary) && (
                        <div className="mt-3 flex flex-wrap gap-2">
                          {/* Show Approve/Reject only when BTR is pending review */}
                          {(selectedRow.btr_status === "Under Review" || selectedRow.btr_status === "Pending") ? (
                            <>
                              <button
                                type="button"
                                onClick={() => handleApproveBtr(selectedRow)}
                                className="inline-flex items-center gap-1 px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white font-bold text-xs rounded-md shadow-xs transition-colors cursor-pointer"
                              >
                                ✓ Approve BTR
                              </button>
                              <button
                                type="button"
                                onClick={() => { setBtrRejectModal(selectedRow); setBtrRejectReason(""); }}
                                className="inline-flex items-center gap-1 px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white font-bold text-xs rounded-md shadow-xs transition-colors cursor-pointer"
                              >
                                ✗ Request Revision
                              </button>
                            </>
                          ) : selectedRow.btr_status === "Rejected" ? (
                            <div className="flex items-center gap-2">
                              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold rounded-md bg-red-100 text-red-700">
                                ✗ Revision Requested
                              </span>
                              <button
                                type="button"
                                onClick={() => {
                                  setBtrContent((selectedRow.btr_content || selectedRow.btr_summary || "").replace(/[-*]?\s*\**Reference No:\**\s*\[Auto-numbered by system\]\s*\n?/gi, ""));
                                  setBtrTab("edit");
                                  setBtrMode("edit");
                                }}
                                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-yellow-500 hover:bg-yellow-600 text-white font-bold text-xs rounded-md shadow-xs transition-colors cursor-pointer"
                              >
                                <i className="fa-solid fa-pen text-[10px]"></i>
                                ✏️ Edit BTR
                              </button>
                            </div>
                          ) : (
                            <span className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold rounded-md ${
                              selectedRow.btr_status === "Approved" ? "bg-green-100 text-green-700" :
                              "bg-gray-100 text-gray-600"
                            }`}>
                              {selectedRow.btr_status === "Approved" ? "✓ BTR Approved" :
                               `BTR Status: ${selectedRow.btr_status}`}
                            </span>
                          )}
                          {getBtrText(selectedRow) && (
                            <button
                              type="button"
                              onClick={() => downloadBtrPdf(selectedRow)}
                              className="inline-flex items-center gap-1 px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white font-medium text-xs rounded-md shadow-xs transition-colors cursor-pointer"
                            >
                              📄 Download BTR (PDF)
                            </button>
                          )}
                          {(selectedRow.btr_file_url || btrFileUrl) && (
                            <button
                              type="button"
                              onClick={() => window.open(selectedRow.btr_file_url || btrFileUrl, "_blank", "noopener")}
                              className="inline-flex items-center gap-1 px-3 py-1.5 bg-slate-600 hover:bg-slate-700 text-white font-medium text-xs rounded-md shadow-xs transition-colors cursor-pointer"
                            >
                              📎 Open Uploaded BTR File
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    /* Create / Attach New BTR (Only when status is Attach BTR) */
                    <>
                      {!btrMode && (
                        <div className="flex flex-wrap gap-3">
                          <button
                            type="button"
                            className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 text-sm font-medium disabled:opacity-50 flex items-center gap-1 shadow-xs"
                            onClick={handleGenerateBtr}
                            disabled={btrLoading}
                          >
                            {btrLoading ? "Generating..." : "✨ Generate BTR (AI)"}
                          </button>
                          <button
                            type="button"
                            className="px-4 py-2 bg-slate-700 text-white rounded-lg hover:bg-slate-800 text-sm font-medium shadow-xs"
                            onClick={() => setBtrMode("upload")}
                          >
                            📁 Upload BTR PDF
                          </button>
                        </div>
                      )}

                      {/* Upload BTR PDF Mode */}
                      {btrMode === "upload" && (
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 mt-3 bg-white p-3 rounded-lg border">
                          <input
                            type="file"
                            accept=".pdf"
                            onChange={(e) => setBtrFile(e.target.files[0])}
                            className="flex-1 px-3 py-2 border rounded-lg text-sm"
                          />
                          <button
                            type="button"
                            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 text-sm font-medium disabled:opacity-50 shadow-xs"
                            onClick={handleBtrFileUpload}
                            disabled={btrLoading || !btrFile}
                          >
                            {btrLoading ? "Uploading..." : "Upload BTR"}
                          </button>
                        </div>
                      )}

                    </>
                  )}

                  {/* Editable BTR Text & Formatted Preview (Available in both states when btrContent is active) */}
                  {btrContent && (
                    <div className="mt-3 bg-white p-3.5 rounded-xl border border-indigo-100 shadow-xs">
                      <div className="flex flex-wrap items-center justify-between border-b pb-2 mb-3 gap-2">
                        <label className="text-xs font-bold text-indigo-950 uppercase tracking-wide">
                          Brief Transmission Report (BTR) Document
                        </label>
                        <div className="flex gap-1 bg-slate-100 p-1 rounded-lg">
                          <button
                            type="button"
                            className={`px-3 py-1 text-xs font-semibold rounded-md transition-all ${btrTab === "preview"
                              ? "bg-white text-indigo-900 shadow-xs"
                              : "text-slate-600 hover:text-slate-900"
                              }`}
                            onClick={() => setBtrTab("preview")}
                          >
                            ✨ Formatted Preview
                          </button>
                          <button
                            type="button"
                            className={`px-3 py-1 text-xs font-semibold rounded-md transition-all ${btrTab === "edit"
                              ? "bg-white text-indigo-900 shadow-xs"
                              : "text-slate-600 hover:text-slate-900"
                              }`}
                            onClick={() => setBtrTab("edit")}
                          >
                            ✏️ Edit Raw Text
                          </button>
                        </div>
                      </div>

                      {btrTab === "preview" ? (
                        <div className="p-3 bg-slate-50/50 rounded-lg border border-slate-200 max-h-80 overflow-y-auto">
                          <FormattedMarkdown content={btrContent} />
                        </div>
                      ) : (
                        <textarea
                          value={btrContent}
                          onChange={(e) => setBtrContent(e.target.value)}
                          className="w-full px-3 py-2 border rounded-lg text-xs sm:text-sm font-mono focus:outline-none focus:ring focus:ring-indigo-300"
                          rows={10}
                        />
                      )}

                      <div className="flex gap-2 mt-3">
                        <button
                          type="button"
                          className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 text-xs font-semibold shadow-xs disabled:opacity-50"
                          onClick={handleSubmitBtr}
                          disabled={btrSubmitLoading}
                        >
                          {btrSubmitLoading ? "Saving..." : "Save & Approve BTR"}
                        </button>
                        <button
                          type="button"
                          className="px-4 py-2 bg-gray-400 text-white rounded-lg hover:bg-gray-500 text-xs font-medium"
                          onClick={() => {
                            setBtrMode(null);
                            setBtrContent("");
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* SECTION 2: Action Taken Report (ATR) — Shown only when status is Attach ATR or Resolved */}
                {(getOfficerGrievanceStatus(selectedRow) === "Attach ATR" ||
                  getOfficerGrievanceStatus(selectedRow) === "Resolved" ||
                  selectedRow.atr_uploaded) && (
                  <>
                    {/* If ATR is already uploaded or status is Resolved — prefilled non-editable ATR card */}
                    {getOfficerGrievanceStatus(selectedRow) === "Resolved" || selectedRow.atr_uploaded ? (
                      <div className="bg-green-50/70 p-4 rounded-xl border border-green-200 mt-4 shadow-xs">
                        <h4 className="text-md font-bold text-green-900 mb-2 flex items-center gap-1.5">
                          ✅ Action Taken Report (ATR)
                        </h4>
                        <div className="flex items-center justify-between bg-white p-3 rounded-lg border border-green-100 mb-3">
                          <div className="flex items-center gap-2">
                            <span className="px-2.5 py-1 bg-green-100 text-green-800 font-semibold text-xs rounded-full">
                              ATR Uploaded
                            </span>
                          </div>
                        </div>

                        <div className="mt-2 bg-white p-3 rounded-lg border border-green-100">
                          <label className="block text-xs font-bold text-green-900 uppercase mb-1">
                            ATR Summary
                          </label>
                          <FormattedMarkdown
                            content={
                              decodeSummary(selectedRow.atr_summary).summary ||
                              selectedRow.atr_summary ||
                              "**Action Taken Report (ATR)** has been uploaded and resolved."
                            }
                          />
                        </div>

                        {(selectedRow.atr_file_url || decodeSummary(selectedRow?.atr_summary).fileUrl) && (
                          <div className="mt-3">
                            <button
                              type="button"
                              className="inline-flex items-center gap-1 px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white font-medium text-xs rounded-md shadow-xs transition-colors"
                              onClick={() => handleATR(selectedRow.grievance_id)}
                            >
                              📄 Download ATR PDF
                            </button>
                          </div>
                        )}
                      </div>
                    ) : (
                      /* Active ATR Management (When status is Attach ATR) */
                      <div className="bg-gray-50 p-4 rounded-xl border border-gray-200 mt-4 shadow-xs">
                        <h4 className="text-md font-bold text-gray-800 mb-2 flex items-center gap-1.5">
                          📄 Action Taken Report (ATR) Management
                        </h4>

                        {!decodeSummary(selectedRow?.atr_summary).summary && !atrSummary && (
                          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 mb-4">
                            <input
                              type="file"
                              accept=".pdf"
                              onChange={(e) => setAtrFile(e.target.files[0])}
                              className="flex-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-green-300 text-sm"
                            />
                            <button
                              type="button"
                              className="px-4 py-2 w-full sm:w-auto bg-green-600 text-white rounded-lg hover:bg-green-700 font-medium text-sm disabled:opacity-50 shadow-xs"
                              onClick={handleAtrUpload}
                              disabled={atrUploadLoading || !atrFile}
                            >
                              {atrUploadLoading ? "Uploading..." : "Upload ATR"}
                            </button>
                          </div>
                        )}

                        {(atrSummary || decodeSummary(selectedRow?.atr_summary).summary) && (
                          <div className="mt-2">
                            <label className="block text-xs font-bold text-gray-700 uppercase mb-1">
                              ATR Summary
                            </label>
                            <div className="w-full px-3 py-3 border rounded-lg bg-white text-gray-700 text-sm max-h-64 overflow-y-auto shadow-inner">
                              <FormattedMarkdown
                                content={atrSummary || decodeSummary(selectedRow?.atr_summary).summary}
                              />
                            </div>
                          </div>
                        )}

                        {!atrSummary && (selectedRow.atr_file_url || (!atrFileUrl && decodeSummary(selectedRow?.atr_summary).fileUrl)) && (
                          <div className="mt-3">
                            <button
                              type="button"
                              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium rounded-md shadow-xs"
                              onClick={() => handleATR(selectedRow.grievance_id)}
                            >
                              📄 Download ATR
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}

                {/* Audio Upload Section - only show after ATR summary is available */}
                {selectedRow?.officer_grievance_status?.toLowerCase() ===
                  "resolved" &&
                  (atrSummary ||
                    decodeSummary(selectedRow?.atr_summary).summary) && (
                    <div className="bg-gray-50 p-4 rounded-lg border mt-4">
                      <h4 className="text-md font-semibold text-gray-800 mb-2">
                        Audio Upload
                      </h4>
                      {!(
                        selectedRow.feedback_call_uploaded &&
                        selectedRow.feedback_call_summary
                      ) && (
                          <div className="mt-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Audio File
                            </label>
                            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4">
                              <input
                                type="file"
                                accept="audio/*"
                                onChange={(e) => setAudioFile(e.target.files[0])}
                                className="flex-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-green-300 text-sm"
                              />
                              <button
                                type="button"
                                className="px-4 py-2 w-full sm:w-auto bg-green-500 text-white rounded hover:bg-green-600 font-medium disabled:opacity-50"
                                onClick={handleAudioUpload}
                                disabled={audioUploadLoading || !audioFile}
                              >
                                {audioUploadLoading
                                  ? "Uploading..."
                                  : "Upload Audio"}
                              </button>
                            </div>
                          </div>
                        )}
                      {(audioSummary ||
                        decodeSummary(selectedRow?.feedback_call_summary).summary) && (
                          <div className="mt-4">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Audio Summary
                            </label>
                            <div className="w-full px-3 py-3 border rounded-lg bg-white text-gray-700 text-sm max-h-64 overflow-y-auto shadow-inner">
                              <FormattedMarkdown
                                content={
                                  audioSummary ||
                                  decodeSummary(selectedRow?.feedback_call_summary)
                                    .summary
                                }
                              />
                            </div>
                          </div>
                        )}
                      {/* {audioFileUrl && (
                      <div className="mt-4">
                        <button
                          type="button"
                          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 font-medium"
                          onClick={handleAudioDownload}
                        >
                          Download Audio
                        </button>
                      </div>
                    )} */}
                    </div>
                  )}

                {/* Buttons */}
                <div className="flex flex-wrap justify-end gap-2 sm:gap-4 pt-4 border-t">
                  <button
                    type="button"
                    className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700 whitespace-nowrap flex items-center gap-1 text-sm"
                    onClick={handleAiSummary}
                  >
                    <AutoAwesomeIcon fontSize="small" /> AI Summary
                  </button>
                  <button
                    type="button"
                    className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 whitespace-nowrap flex-1 sm:flex-none text-center"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  {/* Show Save for: pending grievances OR responded with freshly uploaded ATR OR freshly uploaded Audio */}
                  {(selectedRow?.officer_grievance_status?.toLowerCase() !==
                    "resolved" ||
                    atrSummary ||
                    audioSummary) && (
                      <button
                        type="button"
                        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 whitespace-nowrap flex-1 sm:flex-none text-center"
                        onClick={handleSave}
                      >
                        {loading ? "Saving..." : "Save"}
                      </button>
                    )}
                </div>
              </form>
            </div>
          </div>
        )}

        {isModalOpen && selectedRow && (
          <div className="fixed inset-0 z-[9999] flex items-start sm:items-center justify-center bg-black bg-opacity-50 p-4 sm:p-0">
            <div className="bg-white w-full sm:w-[80vw] max-w-4xl p-5 sm:p-6 rounded shadow-lg max-h-[85vh] sm:max-h-[85vh] overflow-auto mt-6 sm:mt-0">
              <h3 className="text-lg font-bold mb-4">View Complaint</h3>
              <form className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    User Complaint
                  </label>
                  <input
                    type="text"
                    name="user_query"
                    value={selectedRow.user_query}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Bot Response
                  </label>
                  <textarea
                    type="text"
                    name="llm_response_desc"
                    value={selectedRow.llm_response_desc}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={3} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Comment from officer
                  </label>
                  <textarea
                    name="officer_grievance_comments"
                    value={
                      selectedRow?.officer_grievance_comments ||
                      selectedRow?.grievance_response
                    }
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={3} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    User Id
                  </label>
                  <input
                    type="text"
                    name="user_id"
                    value={selectedRow.user_id}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                {/* <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Ministry
                  </label>
                  <input
                    type="text"
                    name="llm_ministry"
                    value={selectedRow.llm_ministry}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div> */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Department
                  </label>
                  <input
                    type="text"
                    name="llm_category"
                    value={selectedRow.llm_category}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Sub Category
                  </label>
                  <input
                    type="text"
                    name="llm_subcategory"
                    value={selectedRow.llm_subcategory}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    State
                  </label>
                  <input
                    type="text"
                    name="state"
                    value={selectedRow.state || ""}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    ATR Summary
                  </label>
                  {isViewOnly ? (
                    <div className="mt-1 w-full px-3 py-3 border rounded-lg bg-gray-50 max-h-64 overflow-y-auto">
                      <FormattedMarkdown content={decodeSummary(selectedRow.atr_summary).summary || selectedRow.atr_summary || "No ATR summary available."} />
                    </div>
                  ) : (
                    <textarea
                      type="text"
                      name="district"
                      value={selectedRow.atr_summary}
                      onChange={(e) => setSelectedRow({ ...selectedRow, atr_summary: e.target.value })}
                      className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                      rows={5}
                    ></textarea>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Feedback Call Summary
                  </label>
                  {isViewOnly ? (
                    <div className="mt-1 w-full px-3 py-3 border rounded-lg bg-gray-50 max-h-64 overflow-y-auto">
                      <FormattedMarkdown content={decodeSummary(selectedRow.feedback_call_summary).summary || selectedRow.feedback_call_summary || "No feedback summary available."} />
                    </div>
                  ) : (
                    <textarea
                      type="text"
                      name="feedback"
                      value={selectedRow.feedback_call_summary}
                      onChange={(e) => setSelectedRow({ ...selectedRow, feedback_call_summary: e.target.value })}
                      className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                      rows={5}
                    ></textarea>
                  )}
                </div>

                {/* BTR View Block */}
                {((selectedRow.btr_status && selectedRow.btr_status !== "None") || selectedRow.btr_file_url || selectedRow.btr_summary || selectedRow.btr_content) && (
                  <div className="bg-blue-50/70 p-4 rounded-xl border border-blue-200">
                    <h4 className="text-md font-bold text-indigo-900 mb-2">
                      📋 Brief Transmission Report (BTR)
                    </h4>

                    {/* BTR Status Banner */}
                    <div className={`flex items-center gap-2 p-2 rounded-lg mb-3 ${
                      selectedRow.btr_status === "Approved" ? "bg-green-50 border border-green-200" :
                      selectedRow.btr_status === "Rejected" ? "bg-red-50 border border-red-200" :
                      "bg-amber-50 border border-amber-200"
                    }`}>
                      {selectedRow.btr_status === "Approved" ? (
                        <span className="text-xs font-bold text-green-700">✓ BTR Approved</span>
                      ) : selectedRow.btr_status === "Rejected" ? (
                        <span className="text-xs font-bold text-red-700">✗ Revision Requested</span>
                      ) : (
                        <span className="text-xs font-bold text-amber-700">⏳ BTR Under Review</span>
                      )}
                    </div>

                    {selectedRow.btr_status === "Rejected" && selectedRow.btr_admin_comment && (
                      <div className="mb-3 p-2 bg-red-50 border border-red-200 rounded text-xs text-red-700">
                        <span className="font-bold">Revision Note: </span>{selectedRow.btr_admin_comment}
                      </div>
                    )}

                    {(selectedRow.btr_summary || selectedRow.btr_content) && (
                      <div className="mt-3 bg-white p-3 rounded-lg border border-indigo-100">
                        <label className="block text-xs font-bold text-indigo-900 uppercase mb-1">
                          BTR Summary / Case Scope
                        </label>
                        <FormattedMarkdown content={getBtrText(selectedRow)} />
                      </div>
                    )}

                    <div className="mt-3 flex flex-wrap gap-2">
                      {/* Under Review: Admin can approve or request revision */}
                      {(selectedRow.btr_status === "Under Review" || selectedRow.btr_status === "Pending") ? (
                        <>
                          <button
                            type="button"
                            onClick={() => handleApproveBtr(selectedRow)}
                            className="inline-flex items-center gap-1 px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white font-bold text-xs rounded-md transition cursor-pointer"
                          >
                            ✓ Approve BTR
                          </button>
                          <button
                            type="button"
                            onClick={() => { setBtrRejectModal(selectedRow); setBtrRejectReason(""); }}
                            className="inline-flex items-center gap-1 px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white font-bold text-xs rounded-md transition cursor-pointer"
                          >
                            ✗ Request Revision
                          </button>
                        </>
                      ) : selectedRow.btr_status === "Rejected" ? (
                        <div className="w-full p-2.5 bg-amber-50 border border-amber-300 rounded-lg text-xs text-amber-800 font-medium">
                          ⏳ <strong>Awaiting Officer Resubmission</strong> — The officer has been asked to revise and resubmit the BTR. It will reappear in the BTR Pending table once resubmitted.
                        </div>
                      ) : null}

                      {getBtrText(selectedRow) && (
                        <button
                          type="button"
                          onClick={() => downloadBtrPdf(selectedRow)}
                          className="inline-flex items-center gap-1 px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white font-medium text-xs rounded-md shadow-xs transition-colors cursor-pointer"
                        >
                          📄 Download BTR (PDF)
                        </button>
                      )}
                      {selectedRow.btr_file_url && (
                        <button
                          type="button"
                          onClick={() => window.open(selectedRow.btr_file_url, "_blank", "noopener")}
                          className="inline-flex items-center gap-1 px-3 py-1.5 bg-slate-600 hover:bg-slate-700 text-white font-medium text-xs rounded-md shadow-xs transition-colors cursor-pointer"
                        >
                          📎 Open Uploaded BTR File
                        </button>
                      )}
                    </div>
                  </div>
                )}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Severity
                  </label>
                  <input
                    type="text"
                    name="severity"
                    value={selectedRow.severity}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Status
                  </label>
                  <input
                    type="text"
                    name="status"
                    value={selectedRow.officer_grievance_status}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    User FeedBack
                  </label>
                  <textarea
                    type="text"
                    name="city"
                    value={selectedRow.user_grievance_feedback_comments}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Admin FeedBack
                  </label>
                  <textarea
                    type="text"
                    name="status"
                    value={selectedRow.admin_feedback}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                {/* <div>
                  {selectedRow.status === "Responded" && (
                    <button
                      className={`w-20 px-2 py-2 text-white rounded mr-2 ${isLiked
                        ? "bg-blue-700 hover:bg-blue-800"
                        : "bg-blue-500 hover:bg-blue-600"
                        }`}
                      onClick={handleLikeClick}
                    >
                      {isLiked ? "Liked" : "Like"}
                    </button>
                  )}

                  {selectedRow.status === "Responded" && (
                    <button
                      className="w-20 px-2 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                      onClick={handleDislikeClick}
                    >
                      Dislike
                    </button>
                  )}

                  {showCommentArea && (
                    <div className="mt-4">
                      <textarea
                        placeholder="Please provide your comment..."
                        className="w-full p-2 border border-gray-300 rounded"
                        rows="4"
                        onChange={(e) => setComment(e.target.value)} // Save comment to state
                      />
                    </div>
                  )}
                </div> */}

                <div className="flex flex-wrap justify-end gap-2 sm:gap-4 pt-4 border-t">
                  <button
                    type="button"
                    className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700 whitespace-nowrap flex items-center gap-1 text-sm"
                    onClick={handleAiSummary}
                  >
                    <AutoAwesomeIcon fontSize="small" /> AI Summary
                  </button>
                  <button
                    type="button"
                    className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                    onClick={handleClose}
                  >
                    Close
                  </button>
                  {/* {selectedrow.officer_grievance_status?.toLowerCase() !== "responded" && (
                    <button
                      type="button"
                      className="px-2 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                      onClick={handleSave1}
                    >
                      {saveLoading ? "Saving..." : "Save"}
                    </button>
                  )} */}
                </div>
              </form>
            </div>
          </div>
        )}

        {/* AI Summary Modal — opened from grievance detail modal */}
        <AiSummaryModal
          isOpen={aiSummaryOpen}
          onClose={() => setAiSummaryOpen(false)}
          summaryText={aiSummaryText}
          loading={aiSummaryLoading}
          grievanceData={selectedRow}
          role="Admin"
        />

        {/* AI Summary Modal — opened inline from Complaints Over Time table */}
        <AiSummaryModal
          isOpen={tableAiSummaryOpen}
          onClose={() => {
            setTableAiSummaryOpen(false);
            setTableAiSummaryText("");
            setTableAiSummaryRow(null);
          }}
          summaryText={tableAiSummaryText}
          loading={tableAiSummaryLoading}
          grievanceData={tableAiSummaryRow}
          role="Admin"
        />

        {/* ATR Full-Content Modal (click to open, scrollable) */}
        {atrPopover && createPortal(
          <div
            className="fixed inset-0 z-[99999] flex items-center justify-center p-4"
            style={{ backgroundColor: 'rgba(0,0,0,0.55)' }}
            onClick={() => setAtrPopover(null)}
          >
            <div
              className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden"
              onClick={e => e.stopPropagation()}
            >
              <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 bg-teal-50 flex-shrink-0">
                <span className="font-bold text-teal-800 text-sm uppercase tracking-wide flex items-center gap-2">
                  <i className="fa-solid fa-file-lines text-teal-600"></i> ATR Summary
                </span>
                <button
                  onClick={() => setAtrPopover(null)}
                  className="w-7 h-7 rounded-full bg-white flex items-center justify-center text-gray-500 hover:bg-gray-100 hover:text-gray-800 transition"
                >
                  <i className="fa-solid fa-xmark text-sm"></i>
                </button>
              </div>
              <div className="overflow-y-auto flex-1 p-5 text-sm text-gray-800 whitespace-pre-wrap leading-relaxed">
                {atrPopover.text}
              </div>
              <div className="flex justify-end px-5 py-3 border-t border-gray-100 flex-shrink-0">
                <button
                  onClick={() => setAtrPopover(null)}
                  className="px-4 py-1.5 bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm font-medium rounded-lg transition"
                >
                  Close
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}

        {/* BTR Detail Modal */}
        {btrDetailModal && (
          <div className="fixed inset-0 z-[9999] bg-black bg-opacity-60 flex items-center justify-center p-4" onClick={() => setBtrDetailModal(null)}>
            <div className="bg-white w-full max-w-3xl rounded-xl shadow-2xl max-h-[90vh] overflow-auto" onClick={e => e.stopPropagation()}>
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-indigo-50">
                <div>
                  <h3 className="font-bold text-lg text-indigo-900">BTR Details</h3>
                  <p className="text-xs text-indigo-600 mt-0.5">Complaint ID: <span className="font-bold">{btrDetailModal.grievance_id}</span></p>
                </div>
                <button onClick={() => setBtrDetailModal(null)} className="w-8 h-8 rounded-full bg-white flex items-center justify-center hover:bg-gray-100 text-gray-600">
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>
              <div className="p-6 space-y-4">
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div><span className="font-semibold text-gray-600">Submitted By:</span> <span className="text-gray-800">{toSentenceCase(btrDetailModal.officer_name) || "—"}</span></div>
                  <div><span className="font-semibold text-gray-600">Department:</span> <span className="text-gray-800">{btrDetailModal.llm_category || "—"}</span></div>
                  <div><span className="font-semibold text-gray-600">Category:</span> <span className="text-gray-800">{btrDetailModal.llm_subcategory || "—"}</span></div>
                  <div><span className="font-semibold text-gray-600">Severity:</span> <span className="text-gray-800">{btrDetailModal.severity || "—"}</span></div>
                  <div><span className="font-semibold text-gray-600">Submission Date:</span> <span className="text-gray-800">{btrDetailModal.btr_timestamp ? new Date(btrDetailModal.btr_timestamp).toLocaleString("en-IN") : "—"}</span></div>
                  <div><span className="font-semibold text-gray-600">District / State:</span> <span className="text-gray-800">{btrDetailModal.district && btrDetailModal.state ? `${btrDetailModal.district}, ${btrDetailModal.state}` : (btrDetailModal.state || "—")}</span></div>
                </div>
                <div>
                  <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
                    <label className="block text-xs font-bold text-indigo-800 uppercase">Full BTR</label>
                    <div className="flex gap-2">
                      {getBtrText(btrDetailModal) && (
                        <button
                          type="button"
                          onClick={() => downloadBtrPdf(btrDetailModal)}
                          className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold rounded-md"
                        >
                          📄 Download PDF
                        </button>
                      )}
                      {btrDetailModal.btr_file_url && (
                        <button
                          type="button"
                          onClick={() => window.open(btrDetailModal.btr_file_url, "_blank", "noopener")}
                          className="px-3 py-1 bg-slate-600 hover:bg-slate-700 text-white text-xs font-semibold rounded-md"
                        >
                          📎 Open Uploaded File
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Show the full btr_content (btr_summary is truncated to ~500 chars) with formatting preserved */}
                  <div className="bg-indigo-50 rounded-lg p-4 text-sm text-gray-700 max-h-[50vh] overflow-y-auto border border-indigo-100">
                    {getBtrText(btrDetailModal)
                      ? <FormattedMarkdown content={getBtrText(btrDetailModal)} />
                      : <span className="text-gray-400">No content available.</span>}
                  </div>
                </div>
                <div className="flex gap-3 pt-2 border-t border-gray-100">
                  <button
                    onClick={() => { handleApproveBtr(btrDetailModal); setBtrDetailModal(null); }}
                    className="px-5 py-2 bg-green-600 hover:bg-green-700 text-white font-bold rounded-lg text-sm transition"
                  >
                    ✓ Approve BTR
                  </button>
                  <button
                    onClick={() => { setBtrRejectModal(btrDetailModal); setBtrRejectReason(""); setBtrDetailModal(null); }}
                    className="px-5 py-2 bg-red-600 hover:bg-red-700 text-white font-bold rounded-lg text-sm transition"
                  >
                    ✗ Request Revision
                  </button>
                  <button
                    onClick={() => setBtrDetailModal(null)}
                    className="px-5 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium rounded-lg text-sm transition ml-auto"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* BTR Reject / Revision Request Modal */}
        {btrRejectModal && (
          <div className="fixed inset-0 z-[9999] bg-black bg-opacity-60 flex items-center justify-center p-4">
            <div className="bg-white w-full max-w-lg rounded-xl shadow-2xl">
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-red-50">
                <div>
                  <h3 className="font-bold text-lg text-red-900">Request BTR Revision</h3>
                  <p className="text-xs text-red-600 mt-0.5">Complaint ID: <span className="font-bold">{btrRejectModal.grievance_id}</span></p>
                </div>
                <button onClick={() => setBtrRejectModal(null)} className="w-8 h-8 rounded-full bg-white flex items-center justify-center hover:bg-gray-100 text-gray-600">
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>
              <div className="p-6 space-y-4">
                <p className="text-sm text-gray-600">
                  Please provide a clear reason for requesting a revision. This will be sent to the officer (<span className="font-semibold">{toSentenceCase(btrRejectModal.officer_name)}</span>) as a notification.
                </p>
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-1.5">Reason for Revision <span className="text-red-500">*</span></label>
                  <textarea
                    value={btrRejectReason}
                    onChange={e => setBtrRejectReason(e.target.value)}
                    placeholder="e.g., Incomplete investigation details, missing evidence, unclear action taken..."
                    rows={4}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  />
                </div>
                <div className="flex gap-3 pt-2">
                  <button
                    onClick={handleRejectBtr}
                    className="px-5 py-2 bg-red-600 hover:bg-red-700 text-white font-bold rounded-lg text-sm transition flex-1"
                  >
                    Send Revision Request
                  </button>
                  <button
                    onClick={() => setBtrRejectModal(null)}
                    className="px-5 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium rounded-lg text-sm transition"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export const getGrievance = async (id) => {
  try {
    const res = await axios.get(`${AUTH_URL}api/grievance?grievance_id=${id}`, {
      headers: { "Content-Type": "application/json" },
    });

    return res.data?.data;
  } catch (error) {
    alert("Data not found");
  }
};
